import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { LeftVector, NotFoundImage, RightVector } from "../../assets";

/**
 * The 404 page of the application.
 *
 * @returns {JSX.Element}
 */

const NotFound = () => {
  const [t] = useTranslation("global");
  return (
    <div className="h-screen w-screen relative">
      <div className="absolute left-0 top-0">
        <img src={LeftVector} alt="" className="w-24 h-24 md:w-48 md:h-48" />
      </div>
      <div className="absolute right-0 bottom-0">
        <img src={RightVector} alt="" className="w-16 md:w-48 h-12 md:h-36" />
      </div>

      <div className="p-4 h-full w-full flex flex-col items-center justify-center">
        <img src={NotFoundImage} alt="404 Page" width={800} height={800} />
        <h2 className="text-center text-2xl font-bold mt-3">
          {t("not_found_text")}
        </h2>
        <div className="flex justify-center w-full mt-4">
          <NavLink
            className="flex items-center px-4 py-2 border border-gray-400 rounded-full text-gray-700 hover:bg-gray-100"
            to="/"
          >
            <Icon
              icon="tabler:arrow-back-up"
              width="20px"
              height="20px"
              className="ms-3"
            />
            {t("back_home_text")}
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
